import { IoAddSharp } from "react-icons/io5";
import { Popup } from "semantic-ui-react";
import CustomInputSeparate from "../../all-patient/components/CuInputSeprate";
import { CustomDropdown } from "../views/ConsultationVitals";
import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import CuSpinner from "../../common_component/component/CuSpinner";

const BpReadings = ({
  bpreadings,
  getUnitOptions,
  setVitals,
  vitalIndx,
  handleSaveConsultation,
  readingLoading,
}) => {
  const handleAddNewReading = (idx) => {
    setVitals((prev) => {
      const prevVitals = [...prev];
      const temp = prevVitals[vitalIndx]?.reading || [];
      temp.push({
        value1: 0,
        value2: 0,
        interval: 5,
        intervalUnit: "Minutes",
        valueUnit: "mmHG",
        timeStamp: "",
      });
      prevVitals[vitalIndx].reading = temp;
      return prevVitals;
    });
  };

  useEffect(() => {
    if (bpreadings?.reading?.length === 0) {
      handleAddNewReading();
    }
  }, [bpreadings]);

  const handleDeleteReading = (idx) => {
    setVitals((prev) => {
      const prevVitals = [...prev];
      const temp = prevVitals[vitalIndx]?.reading || [];
      temp?.splice(idx, 1);
      prevVitals[vitalIndx].reading = temp;
      return prevVitals;
    });
  };

  const handleUnitChange = (idx, selectedUnit, unitType) => {
    setVitals((prev) => {
      const prevVitals = [...prev];
      const temp = prevVitals[vitalIndx]?.reading || [];
      temp[idx][unitType] = selectedUnit;
      prevVitals[vitalIndx].reading = temp;
      return prevVitals;
    });
  };

  const handleReadingChange = (idx, val) => {
    const valArray = val?.split("/");
    const valObj = {};
    valArray?.forEach((ele, index) => (valObj[`value${index + 1}`] = ele));
    setVitals((prev) => {
      const prevVitals = [...prev];
      const temp = prevVitals[vitalIndx]?.reading || [];
      temp[idx] = { ...temp[idx], ...valObj };
      prevVitals[vitalIndx].reading = temp;
      return prevVitals;
    });
  };

  const handleSaveReading = () => {
    setVitals((prev) => {
      const prevVitals = [...prev];
      const temp = prevVitals[vitalIndx]?.reading || [];
      const modifiedReading = temp?.map((reading) => ({
        ...reading,
        timeStamp: new Date().toISOString(),
      }));
      prevVitals[vitalIndx].reading = modifiedReading;
      return prevVitals;
    });
    handleSaveConsultation("draft", "reading");
  };

  return (
    <Popup
      trigger={<IoAddSharp className="cursor-pointer" />}
      on={"click"}
      hoverable
      content={
        <div className="p-2">
          {bpreadings?.reading?.map((vital, i) => {
            return (
              <div key={i} className="flex items-end gap-3">
                <div className="">
                  <label>BP</label>
                  <div className="cu-consultation-vital-input-cont cu-consultation-vital-input">
                    <CustomInputSeparate
                      separator="/"
                      maxLength={3}
                      fieldCount={2}
                      initialValues={[
                        vital?.value1 === 0 ? "" : vital?.value1,
                        vital?.value2 === 0 ? "" : vital?.value2,
                      ]}
                      inputWidth={`30px`}
                      // className={`cu-consultation-vital-input`}
                      onChange={(value) => handleReadingChange(i, value)}
                      unit={vital?.valueUnit}
                      label={"BP"}
                    />

                    <CustomDropdown
                      options={getUnitOptions(bpreadings?.type?.unit)}
                      value={vital?.valueUnit}
                      onChange={(selectedUnit) =>
                        handleUnitChange(i, selectedUnit, "valueUnit")
                      }
                    />
                  </div>
                </div>
                <div>
                  <label>Interval</label>
                  <div className="cu-consultation-vital-input-cont cu-consultation-vital-input">
                    <CustomInputSeparate
                      separator="/"
                      maxLength={3}
                      fieldCount={1}
                      initialValues={[vital?.interval]}
                      inputWidth={`35px`}
                      // className={`cu-consultation-vital-input`}
                      unit={vital?.intervalUnit}
                      label={"Interval"}
                    />

                    <CustomDropdown
                      options={getUnitOptions("Minutes, Second, Hours")}
                      value={vital?.intervalUnit}
                      onChange={(selectedUnit) =>
                        handleUnitChange(i, selectedUnit, "intervalUnit")
                      }
                    />
                  </div>
                </div>
                <div>
                  {i === bpreadings?.reading?.length - 1 ? (
                    <IoAddSharp
                      onClick={() => handleAddNewReading(i)}
                      className="cursor-pointer"
                    />
                  ) : (
                    <IoMdClose
                      className="cursor-pointer"
                      onClick={() => handleDeleteReading(i)}
                    />
                  )}
                </div>
              </div>
            );
          })}
          <div className="flex justify-end mt-3 pr-3">
            <button
              className="h-[30px] bg-[#C7EAC9] rounded text-[#575757] flex border justify-center items-center min-w-[55px]"
              onClick={handleSaveReading}
            >
              {readingLoading ? <CuSpinner /> : "Save"}
            </button>
          </div>
        </div>
      }
    />
  );
};

export default BpReadings;
